import React from 'react';
import { IProps } from './types';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import _ from 'lodash';
import { Code, SysOption, SysOptionReq } from 'bff/models/info';
import { PaymentMethod } from 'constants/enums/paymentMethod.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import { PaymentContent, BankContent } from 'bff/models/product/paymentMethod';
import { InsuredRoleType } from 'constants/enums/insuredRoleType.enum';
import { InsuredState } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import InputWithRegex from 'components/InputWithRegex';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import service from 'bff/services/travelProductService';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import { IPaymentFormValue, IPaymentState } from 'constants/models/components/insurProcess/insureProcessPayment';
import { PaymentNccReq, PaymentEBillReq } from 'bff/models/product';
import sweetAlertService from 'utils/sweetAlertService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { PayerContent } from 'bff/models/member/boPayby';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { InsCount } from 'constants/enums/insCount.enum';
import { InsureSubject } from 'constants/enums/insureSubject.enum';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { CodeId } from 'constants/enums/codeId.enum';

const initval: IPaymentFormValue = {
  PAYMENT_METHOD: PaymentMethod.CreditCard, // 'credit-card',
  PAYMENT_CLAIM: false,
  BANK_PAYER_TYPE: InsuredRoleType.Application,
  CREDIT_PAYER_TYPE: InsuredRoleType.Application,
  BANK_PAYER_ID: '',
  CREDIT_PAYER_ID: '',
  PAN1st: '',
  PAN2nd: '',
  PAN3rd: '',
  PAN4th: '',
  CARD_VERIFY_CODE: '',
  EXPIREDATE_MONTH: '',
  EXPIREDATE_YEAR: '',
  BANK_CODE: '',
  BANK_ACCOUNT: ''
};

let initialValues: IPaymentFormValue = initval;

const validationSchema = Yup.object().shape({
  PAYMENT_METHOD: Yup.string().required('此為必填欄位'),
  CREDIT_PAYER_TYPE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。') : schema;
  }),
  CREDIT_PAYER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。') : schema;
  }),
  PAN1st: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度不可超過（少於）4 字元') : schema;
  }),
  PAN2nd: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度不可超過（少於）4 字元') : schema;
  }),
  PAN3rd: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度不可超過（少於）4 字元') : schema;
  }),
  PAN4th: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度不可超過（少於）4 字元') : schema;
  }),
  EXPIREDATE_MONTH: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(2, '長度不可超過（少於）2 字元') : schema;
  }),
  EXPIREDATE_YEAR: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(2, '長度不可超過（少於）2 字元') : schema;
  }),
  CARD_VERIFY_CODE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(3, '長度不可超過（少於）3 字元') : schema;
  }),
  BANK_PAYER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。') : schema;
  }),
  BANK_PAYER_TYPE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。') : schema;
  }),
  BANK_CODE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。') : schema;
  }),
  BANK_ACCOUNT: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
    return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。').min(11, '長度不可少於 11 字元').max(14, '長度不可超過 14 字元') : schema;
  })
});

class InsureProcessPayment extends React.PureComponent<IProps, IPaymentState> {
  private tempFill2ndFormVal = this.props.tempFill2nd.tempFill2ndFormVal
  private formikRef: any = React.createRef();

  state: IPaymentState = {
    activePaymentMethod: PaymentMethod.CreditCard,
    activeInsRoleType: InsuredRoleType.Application,
    agreeContract: false,
    insRoleTypeSysOpts: new Array(0),
    showBarCode: false
  }

  componentDidMount = async () => {
    commonService.scrollToTop();
    let showBarCode = false;

    // 若有暫存資料，初始化暫存資料
    if (this.props.tempPayment &&
      this.props.tempPayment.tempPaymentFormVal &&
      this.props.tempPayment.tempPaymentState &&
      this.props.tempCalc &&
      this.props.tempCalc.tempCalcFormVal
    ) {
      const insuredRange = this.props.tempFill1st.tempFill1stFormVal?.INSURED_RANGE || new Array(0);
      const applyType = this.props.tempFill2nd.tempFill2ndState?.applyType as string;
      // const fee = this.props.tempFill2nd?.tempFill2ndState?.planData?.HEADER.TOTAL || ''
      const fee = this.tempFill2ndFormVal?.INSUREDS.reduce((acc, cur) => acc + +cur.INSURED_CALC, 0).toString();
      showBarCode = await this.handleValidateShowBarCode(insuredRange[0], applyType, fee);

      const isSelf = this.props.tempCalc.tempCalcFormVal.INS_COUNT === InsCount.One &&
        this.props.tempCalc.tempCalcFormVal.INSURED_SUBJECT === InsureSubject.Self;

      const barCodeError = !showBarCode && this.props.tempPayment.tempPaymentFormVal.PAYMENT_METHOD === PaymentMethod.BarCode;

      initialValues = {
        ...initialValues,
        ...this.props.tempPayment.tempPaymentFormVal
      };

      if (isSelf || barCodeError) {
        initialValues = {
          ...initialValues,
          PAYMENT_METHOD: PaymentMethod.CreditCard,
          BANK_PAYER_TYPE: InsuredRoleType.Application,
          BANK_PAYER_ID: this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID || '',
          CREDIT_PAYER_TYPE: InsuredRoleType.Application,
          CREDIT_PAYER_ID: this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID || ''
        };
      }

      this.setState({
        ...this.props.tempPayment.tempPaymentState,
        showBarCode: showBarCode,
        activePaymentMethod: barCodeError
          ? PaymentMethod.CreditCard
          : this.props.tempPayment.tempPaymentState.activePaymentMethod
      });

      if (isSelf || barCodeError) {
        this.setState({
          activeInsRoleType: InsuredRoleType.Application
        });
      }

      return;
    }

    // 若有後台補繳費資料
    if (this.props.boPayby) {
      const applicant = _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);
      initialValues = {
        ...initialValues,
        BANK_PAYER_ID: applicant?.ID || '',
        CREDIT_PAYER_ID: applicant?.ID || ''
      };
      showBarCode = await this.handleValidateShowBarCode(this.props.boPayby.START_DATE, this.props.boPayby.BC_TYPE, this.props.boPayby.POLICY_FEE);
    } else {
      initialValues = {
        ...initialValues,
        BANK_PAYER_ID: this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID || '',
        CREDIT_PAYER_ID: this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID || ''
      };
      const insuredRange = this.props.tempFill1st.tempFill1stFormVal?.INSURED_RANGE || new Array(0);
      const applyType = this.props.tempFill2nd.tempFill2ndState?.applyType as string;
      // const fee = this.props.tempFill2nd?.tempFill2ndState?.planData?.HEADER.TOTAL || ''
      const fee = this.tempFill2ndFormVal?.INSUREDS.reduce((acc, cur) => acc + +cur.INSURED_CALC, 0).toString();
      showBarCode = await this.handleValidateShowBarCode(insuredRange[0], applyType, fee);
    }

    await this.handleFetchSysOpts();
    this.setState(prevState => {
      return {
        ...prevState,
        showBarCode: showBarCode
      }
    });
    // console.log('payment tempState', JSON.stringify(this.props.tempState));
  }

  componentWillUnmount() {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;

    this.props.onUnmount(formVal, this.state);

    initialValues = {
      ...initval
    };
  }

  /**
   * @description 判斷是否顯示 Barcode 付費
   */
  handleValidateShowBarCode = async (insuredDate: any, applyType: string, fee: any) => {
    if (applyType !== ApplyType.WebRequire) return false;

    if (isNaN(+fee) || +fee >= 50000) return false;

    if (!moment(insuredDate).isValid()) return false;

    const serverTimeMs = await apiCommonService.fetchSysTime();
    const validDate = moment(serverTimeMs).add(7, 'd');

    return moment(insuredDate).isAfter(validDate);
  }

  /**
    * @description 取得系統參數值
  */
  handleFetchSysOpts = async () => {
    const sysOptionReq: SysOptionReq = {
      PCLASS: [SysOptType.INSROLETYPE]
    };

    const res = await apiCommonService.fetchSysOpts(sysOptionReq);

    if (res) {
      this.setState({
        insRoleTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.INSROLETYPE]))
      });
    }
  }

  /**
   * @description 取得付款人姓名
  */
  handleGetPayerName = (payerType: string, memberId: string) => {
    if (this.props.boPayby) {
      return _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.ID === memberId)?.NAME || '';
    }

    if (payerType === InsuredRoleType.Application) {
      return this.props.tempFill2nd.tempFill2ndFormVal?.NAME || '';
    }

    const insureds = this.props.tempFill2nd?.tempFill2ndFormVal?.INSUREDS;

    const insured = _.find(insureds, (insured: InsuredState) => insured.INSURED_ID === memberId);
    if (!insured) return '';

    return insured.INSURED_NAME;
  }

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: IPaymentFormValue) => {
    const btnPay = document.getElementById("btn_pay") as HTMLButtonElement;
    if (!btnPay) return;

    btnPay.disabled = true;

    if (values.PAYMENT_METHOD !== PaymentMethod.BarCode) {
      // const fee = this.props.boPayby ? `${this.props.boPayby.POLICY_FEE}` : this.props.tempFill2nd?.tempFill2ndState?.planData?.HEADER.TOTAL || '';
      const fee = this.props.boPayby ? `${this.props.boPayby.POLICY_FEE}` : this.tempFill2ndFormVal?.INSUREDS.reduce((acc, cur) => acc + +cur.INSURED_CALC, 0).toString();
      const applyNo = this.props.boPayby ? this.props.boPayby.APPLY_NO : this.props.tempFill2nd.tempFill2ndState?.serialNo || '';

      // 執行線上付款-信用卡
      if (this.state.activePaymentMethod === PaymentMethod.CreditCard) {
        const paymentNccReq: PaymentNccReq = {
          APPLY_NO: applyNo,
          PAN: `${values.PAN1st}${values.PAN2nd}${values.PAN3rd}${values.PAN4th}`,
          EXPIREDATE: `${values.EXPIREDATE_MONTH}${values.EXPIREDATE_YEAR}`,
          TRANSAMT: fee || '',
          IDNUMBER: values.CREDIT_PAYER_ID,
          PAYER_NAME: this.handleGetPayerName(values.CREDIT_PAYER_TYPE, values.CREDIT_PAYER_ID)
        };
        // console.log('paymentNccReq', paymentNccReq);
        const res = await service.paymentNccc(paymentNccReq);
        if (!res) {
          btnPay.disabled = false;
          return;
        }
      }

      // 執行線上付款-活期帳戶
      if (this.state.activePaymentMethod === PaymentMethod.BankAccount) {
        const paymentEBillReq: PaymentEBillReq = {
          personId: values.BANK_PAYER_ID,
          trnsOutBank: values.BANK_CODE,
          trnsOutAcct: values.BANK_ACCOUNT,
          // 總比數固定帶 1
          totalCount: '1',
          totalAmount: fee || '',
          APPLY_NO: applyNo,
          PAYER_NAME: this.handleGetPayerName(values.BANK_PAYER_TYPE, values.BANK_PAYER_ID)
        };
        // console.log('paymentEBillReq', paymentEBillReq);
        const res = await service.paymentEBill(paymentEBillReq);
        if (!res) {
          btnPay.disabled = false;
          return;
        }
      }
    }

    this.props.onSubmit(values, this.state);
    btnPay.disabled = false;
  };

  /**
   * @description 取得投保金額
  */
  handleGetFee = () => {
    // if (this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndState) {
    //   return `NT$ ${commonService.thousandFormat(this.props.tempFill2nd?.tempFill2ndState?.planData?.HEADER.TOTAL || '')}`;
    // }
    if (this.tempFill2ndFormVal && this.tempFill2ndFormVal.INSUREDS && this.tempFill2ndFormVal.INSUREDS.length > 0) {
      return `NT$ ${commonService.thousandFormat(this.tempFill2ndFormVal.INSUREDS.reduce((acc, cur) => acc + +cur.INSURED_CALC, 0).toString())}`;
    }

    if (this.props.boPayby) {
      return `NT$ ${commonService.thousandFormat(this.props.boPayby.POLICY_FEE ? `${this.props.boPayby.POLICY_FEE}` : '')}`;
    }
  }

  render() {
    const { tempCalcFormVal } = this.props.tempCalc;

    const isSelf = tempCalcFormVal?.INS_COUNT === InsCount.One && tempCalcFormVal?.INSURED_SUBJECT === InsureSubject.Self;
    // #region 產生付款方式區塊

    let paymentMethod: any;
    if (Object.keys(this.props.paymentMethod.PAYMENT_INFO.PAYMENT_OPTION[0]).length > 0) {
      const paymentOpt = { ...this.props.paymentMethod.PAYMENT_INFO.PAYMENT_OPTION[0] };

      const optkeys = Object.keys(paymentOpt);
      paymentMethod = _.map(optkeys, (optkey: string, index: number) => {

        if (!this.state.showBarCode && optkey === PaymentMethod.BarCode) return;

        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`credit-card-radio${index}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="PAYMENT_METHOD"
                  id={`credit-card-radio${index}`}
                  value={optkey}
                  onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const setFieldValue = this.formikRef.current.setFieldValue;
                    if (this.state.activePaymentMethod !== e.currentTarget.value) {
                      setFieldValue('CREDIT_PAYER_TYPE', InsuredRoleType.Application);
                      setFieldValue('BANK_PAYER_TYPE', InsuredRoleType.Application);
                      if (this.props.boPayby) {
                        const applicant = _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);
                        setFieldValue('BANK_PAYER_ID', applicant?.ID);
                        setFieldValue('CREDIT_PAYER_ID', applicant?.ID);
                      } else {
                        setFieldValue('BANK_PAYER_ID', this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID);
                        setFieldValue('CREDIT_PAYER_ID', this.props.tempFill2nd.tempFill2ndFormVal?.MEMBER_ID);
                      }
                    }
                    if (e.target.value === PaymentMethod.BarCode) {
                      sweetAlertService.modal({
                        icon: SweetAlertIcon.Info,
                        title: '行動條碼繳費說明',
                        html: commonService.getCodeMsg(this.props.UICode, CodeId.U040)
                      });
                    }
                    setFieldValue('PAYMENT_METHOD', e.currentTarget.value);
                    this.setState({ activePaymentMethod: e.currentTarget.value, activeInsRoleType: InsuredRoleType.Application });
                  }}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{paymentOpt[optkey]}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 產生繳費提示訊息區塊、銀行下拉選單值

    let paymentInfo: JSX.Element;
    let bankOpts: JSX.Element[];
    if (this.props.paymentMethod && (this.props.boPayby || (this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndState && this.props.tempFill2nd.tempFill2ndFormVal))) {
      let payment: PaymentContent = { ...this.props.paymentMethod.PAYMENT_INFO.COMMON_MSG.BANKACCOUNT };

      if (this.state.activePaymentMethod === PaymentMethod.CreditCard) {
        payment = { ...this.props.paymentMethod.PAYMENT_INFO.COMMON_MSG.CREDITCARD };
      }

      const applyType = this.props.boPayby ? this.props.boPayby.BC_TYPE : this.props.tempFill2nd?.tempFill2ndState?.applyType || '';

      let paymentInfoStr: string = payment.NOTICE_B;
      if (applyType === ApplyType.WebInsured) {
        paymentInfoStr = payment.NOTICE_C;
      }

      // 建立銀行的下拉選單
      bankOpts = _.map(payment.BANK, (bank: BankContent, index: number) => {
        return <option value={bank.ID} key={index}>{`${bank.ID} ${bank.NAME}`}</option>;
      });

      const applyCantName = this.props.boPayby
        ? _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant)?.NAME || ''
        : this.props.tempFill2nd?.tempFill2ndFormVal?.NAME;
      paymentInfo = (
        <div className="insure-process-payment__part">
          <span className="insure-process-payment__part-title">{`親愛的${applyCantName}您好，`}</span>
          <p>{paymentInfoStr}</p>
          {
            this.state.activePaymentMethod === PaymentMethod.CreditCard
              ? <span className="element__link" onClick={() => handleShowAvailableBank(payment)}>目前可配合之發卡銀行</span>
              : null
          }
        </div>
      );
    }

    /**
     * @description 顯示可用銀行
    */
    const handleShowAvailableBank = (payment: PaymentContent) => {
      const msg = _.reduce(_.map(payment.BANK, (content: BankContent) => content.NAME), (res: string, curr: string) => {
        return `${res}、${curr}`;
      });

      sweetAlertService.modal({
        title: '可配合之發卡銀行',
        html: `<div class="cooperate-bank-modal__content">${msg}</div>`
      });
    };

    // #endregion

    // #region 產生線上繳費權益告知聲明事項區塊
    let paymentClaim: JSX.Element;
    if (this.props.paymentMethod) {
      paymentClaim = (
        <>
          <span className="insure-process-payment__part-title">{this.props.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.HEAD}</span>
          <p>{commonService.htmlParser(this.props.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.BODY)}</p>
          <br />
          <div className="element__checkbox-group">
            <label htmlFor="receive-information-checkbox">
              <div className="element__checkbox">
                <Field
                  type="checkbox"
                  name="PAYMENT_CLAIM"
                  id="receive-information-checkbox"
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    this.setState({ agreeContract: e.currentTarget.checked });
                  }}
                />
                <div className="element__checkbox-btn" />
              </div>
              <span>{this.props.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.ANSWER.BODY}</span>
            </label>
          </div>
        </>
      );
    }
    // #endregion

    // #region 產生被保人/要保人選項區塊

    let insRole: JSX.Element[];
    if (this.state.insRoleTypeSysOpts && this.state.insRoleTypeSysOpts.length > 0) {
      insRole = _.map(this.state.insRoleTypeSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div
            className="element__radio-group" key={index}
          >
            <label htmlFor={`insRole-radio${index}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name={this.state.activePaymentMethod === PaymentMethod.CreditCard ? 'CREDIT_PAYER_TYPE' : 'BANK_PAYER_TYPE'}
                  id={`insRole-radio${index}`}
                  value={sysOpt.PARAM_VALUE}
                  disabled={isSelf}
                  onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const activeInsRoleType = this.state.activeInsRoleType;
                    if (activeInsRoleType !== e.currentTarget.value) {
                      const fieldName = this.state.activePaymentMethod === PaymentMethod.CreditCard ? 'CREDIT_PAYER_ID' : 'BANK_PAYER_ID';
                      this.formikRef.current.setFieldValue(fieldName, '');
                    }
                    this.setState({ activeInsRoleType: e.currentTarget.value });
                  }}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 依付款人身分顯示姓名下拉選單

    let roleTypeOtps: any = null;
    if (this.state.activeInsRoleType && (this.props.boPayby || (this.props.tempFill2nd && this.props.tempFill2nd.tempFill2ndFormVal))) {
      switch (this.state.activeInsRoleType) {
        case InsuredRoleType.Application:
          roleTypeOtps = this.props.boPayby ? _.map(
            _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant), (payer: PayerContent, index: number) => {
              return <option key={index} value={payer.ID}>{payer.NAME}</option>;
            })
            : (
              <option value={this.props.tempFill2nd?.tempFill2ndFormVal?.MEMBER_ID}>{this.props.tempFill2nd?.tempFill2ndFormVal?.NAME}</option>
            );
          break;
        case InsuredRoleType.Insured:
          roleTypeOtps = this.props.boPayby
            ? _.map(
              _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured), (payer: PayerContent, index: number) => {
                return <option key={index} value={payer.ID}>{payer.NAME}</option>;
              })
            : _.map(this.props.tempFill2nd?.tempFill2ndFormVal?.INSUREDS, (insured: InsuredState, index: number) => {
              return <option key={index} value={insured.INSURED_ID}>{insured.INSURED_NAME}</option>;
            })
            ;
          break;
      }
    }

    // #endregion

    /**
     * @description 建立 BarCode 區塊
     */
    const handleCreateBarCode = () => {
      let policyholderName;
      let dueDate;
      let insuredName;
      let activePlanName;
      let fee;
      if (this.props.boPayby && this.props.boPayby.APPLY_NO) {
        const policyholders =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

        const insureds =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        policyholderName = policyholders[0].NAME;
        dueDate = moment(this.props.boPayby.START_DATE).isValid()
          ? moment(this.props.boPayby.START_DATE).add(-7, 'd').format(`YYYY年MM月DD日 ${this.props.boPayby.START_HOUR}:00`)
          : '';
        insuredName = insureds[0].NAME;
        activePlanName = this.props.boPayby.PROD_NAME;
        fee = this.props.boPayby.POLICY_FEE;
      }

      const { tempFill1stFormVal } = this.props.tempFill1st;
      const { tempFill2ndState, tempFill2ndFormVal } = this.props.tempFill2nd;
      if (tempFill1stFormVal && tempFill2ndState && tempFill2ndFormVal) {
        policyholderName = tempFill2ndFormVal.NAME;
        const insuredDate = tempFill1stFormVal.INSURED_RANGE || [];

        const startHour = moment(tempFill1stFormVal.INSURED_TIME).format('HH');

        dueDate = moment(insuredDate[0]).isValid()
          ? moment(insuredDate[0]).add(-7, 'd').format(`YYYY年MM月DD日 ${startHour}:00`)
          : '';
        insuredName = tempFill2ndFormVal.INSUREDS[0].INSURED_NAME;
        activePlanName = tempFill2ndState.planData?.HEADER.MAINTITLE;
        // fee = tempFill2ndState.planData?.HEADER.TOTAL;
        fee = this.tempFill2ndFormVal?.INSUREDS.reduce((acc, cur) => acc + +cur.INSURED_CALC, 0).toString();
      }

      return (
        <div className="insure-process-payment__list">
          <div className="element__list">
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">要保人姓名</div>
                <div className="element__list-group-content">{policyholderName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">繳費期限</div>
                <div className="element__list-group-content">{dueDate}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">被保險人姓名</div>
                <div className="element__list-group-content">{insuredName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">投保方案</div>
                <div className="element__list-group-content">{activePlanName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">保費金額</div>
                <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(`${fee}`)} 元`}</div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="insure-process-payment">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={this.handleFormSubmit}
          innerRef={this.formikRef}
          enableReinitialize
        >
          {({ errors, touched, values, handleBlur, handleChange, setFieldTouched }) => (
            <Form>
              <div className="insure-process-payment__title">選擇支付方式</div>
              <div className="insure-process-payment__content">
                <div className="insure-process-payment__row">
                  {paymentMethod}
                </div>
                {
                  this.state.activePaymentMethod === PaymentMethod.BarCode && handleCreateBarCode()
                }
                {
                  this.state.activePaymentMethod !== PaymentMethod.BarCode && (
                    <>
                      {paymentInfo}
                      <div className="insure-process-payment__part">
                        {paymentClaim}
                      </div>
                    </>
                  )
                }
                {
                  <div className="insure-process-payment__payment-form">
                    {this.state.activePaymentMethod === PaymentMethod.CreditCard && this.state.agreeContract && (
                      <div className="insure-process-payment__credit-cards">
                        <div className="insure-process-payment__credit-card">
                          <div className="insure-process-payment__credit-card-container">
                            <div className="insure-process-payment__row">
                              <span>金額</span>
                              <span>{this.handleGetFee()}</span>
                            </div>
                            <div className="insure-process-payment__row">
                              <div
                                className={'element__form-group' + (
                                  (errors.PAN1st && touched.PAN1st) ||
                                    (errors.PAN2nd && touched.PAN2nd) ||
                                    (errors.PAN3rd && touched.PAN3rd) ||
                                    (errors.PAN4th && touched.PAN4th) ? ' element__form-group--invalid' : ''
                                )}
                              >
                                <div className="element__form-group-title">信用卡卡號</div>
                                <div className="element__form-group-content">
                                  <Field
                                    component={InputWithRegex}
                                    id="pan1st-input"
                                    name="PAN1st"
                                    className="element__input"
                                    maxLength="4"
                                    style={{ width: '25%' }}
                                    onBlur={() => {
                                      setFieldTouched('PAN1st', true);
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      handleChange(e);
                                      commonService.setInputAutoFocus('pan1st-input', 'pan2nd-input');
                                    }}
                                  />
                                  <Field
                                    component={InputWithRegex}
                                    id="pan2nd-input"
                                    name="PAN2nd"
                                    className="element__input"
                                    maxLength="4"
                                    style={{ width: '25%' }}
                                    onBlur={() => {
                                      setFieldTouched('PAN2nd', true);
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      handleChange(e);
                                      commonService.setInputAutoFocus('pan2nd-input', 'pan3rd-input');
                                    }}
                                  />
                                  <Field
                                    component={InputWithRegex}
                                    id="pan3rd-input"
                                    name="PAN3rd"
                                    className="element__input"
                                    maxLength="4"
                                    style={{ width: '25%' }}
                                    onBlur={() => {
                                      setFieldTouched('PAN3rd', true);
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      handleChange(e);
                                      commonService.setInputAutoFocus('pan3rd-input', 'pan4th-input');
                                    }}
                                  />
                                  <Field
                                    component={InputWithRegex}
                                    id="pan4th-input"
                                    name="PAN4th"
                                    style={{ width: '25%' }}
                                    className="element__input"
                                    maxLength="4"
                                    onBlur={() => {
                                      setFieldTouched('PAN4th', true);
                                    }}
                                  />
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.PAN1st && touched.PAN1st ? <ErrorMessage name="PAN1st" />
                                      : errors.PAN2nd && touched.PAN2nd ? <ErrorMessage name="PAN2nd" />
                                        : errors.PAN3rd && touched.PAN3rd ? <ErrorMessage name="PAN3rd" />
                                          : errors.PAN4th && touched.PAN4th ? <ErrorMessage name="PAN4th" /> : ''
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="insure-process-payment__row">
                              <div className={'element__form-group' + (
                                (errors.EXPIREDATE_MONTH && touched.EXPIREDATE_MONTH) ||
                                  (errors.EXPIREDATE_YEAR && touched.EXPIREDATE_YEAR) ? ' element__form-group--invalid' : ''
                              )}
                              >
                                <div className="element__form-group-title">信用卡到期(月/年)</div>
                                <div className="element__form-group-content">
                                  <Field
                                    component={InputWithRegex}
                                    id="expire-date-month-input"
                                    name="EXPIREDATE_MONTH"
                                    className="element__input"
                                    maxLength="2"
                                    onBlur={() => {
                                      setFieldTouched('EXPIREDATE_MONTH', true);
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      handleChange(e);
                                      commonService.setInputAutoFocus('expire-date-month-input', 'expire-date-year-input');
                                    }}
                                    validate={(val: any) => {
                                      const reg = /((0[1-9]{1})|(1[0-2]{1}))/;
                                      if (val && !reg.test(val)) return '有效月份需為 01-12';

                                      return '';
                                    }}
                                  />
                                  <span>/</span>
                                  <Field
                                    component={InputWithRegex}
                                    id="expire-date-year-input"
                                    name="EXPIREDATE_YEAR"
                                    className="element__input"
                                    maxLength="2"
                                    onBlur={() => {
                                      setFieldTouched('EXPIREDATE_YEAR', true);
                                    }}
                                    validate={(val: any) => {
                                      const nowYear = moment().format('YYYY');
                                      const validYear = +nowYear.substr(2, 2);
                                      if (val && +val < validYear) return `有效年份需大於 (等於) ${nowYear}`;

                                      return '';
                                    }}
                                  />
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.EXPIREDATE_MONTH && touched.EXPIREDATE_MONTH
                                      ? <ErrorMessage name="EXPIREDATE_MONTH" />
                                      : errors.EXPIREDATE_YEAR && touched.EXPIREDATE_YEAR
                                        ? <ErrorMessage name="EXPIREDATE_YEAR" /> : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="insure-process-payment__credit-card">
                          <div className="insure-process-payment__credit-card-container">
                            <div className="insure-process-payment__row">
                              <div className={'element__form-group' + ((errors.CREDIT_PAYER_TYPE && touched.CREDIT_PAYER_TYPE) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-content">
                                  {insRole}
                                </div>
                                <div className="element__error-message">
                                  <ErrorMessage name="CREDIT_PAYER_TYPE" />
                                </div>
                              </div>
                            </div>
                            <div className="insure-process-payment__row">
                              <div className={'element__form-group' + ((errors.CREDIT_PAYER_ID && touched.CREDIT_PAYER_ID) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">扣款人姓名</div>
                                <Field as="select" disabled={isSelf} name="CREDIT_PAYER_ID" className="element__select">
                                  <option value="">請選擇</option>
                                  {roleTypeOtps}
                                </Field>
                                <div className="element__error-message">
                                  <ErrorMessage name="CREDIT_PAYER_ID" />
                                </div>
                              </div>
                              <div className={'element__form-group' + ((errors.CARD_VERIFY_CODE && touched.CARD_VERIFY_CODE) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">三碼檢查碼</div>
                                <Field
                                  component={InputWithRegex}
                                  id="card-verify-code-input"
                                  autoComplete="off"
                                  name="CARD_VERIFY_CODE"
                                  className="element__input" maxLength={3}
                                  onBlur={() => {
                                    setFieldTouched('CARD_VERIFY_CODE', true);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="CARD_VERIFY_CODE" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.activePaymentMethod === PaymentMethod.BankAccount && this.state.agreeContract && (
                      <div className="insure-process-payment__current-account">
                        <div className="insure-process-payment__current-account-container">
                          <div className="insure-process-payment__row">
                            <span>金額</span>
                            <span>{this.handleGetFee()}</span>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (errors.BANK_CODE && touched.BANK_CODE ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-content">
                                <span>銀行</span>
                                <Field as="select" name="BANK_CODE" className="element__select">
                                  <option value="">請選擇</option>
                                  {bankOpts}
                                </Field>
                              </div>
                              <ErrorMessage name="BANK_CODE" component="div" className="element__error-message" />
                            </div>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (errors.BANK_ACCOUNT && touched.BANK_ACCOUNT ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-content">
                                <span>帳號</span>
                                <Field
                                  component={InputWithRegex}
                                  id="bank-account-input"
                                  autoComplete="off"
                                  name="BANK_ACCOUNT"
                                  className="element__input"
                                  maxLength="14"
                                  onBlur={() => {
                                    setFieldTouched('BANK_ACCOUNT', true);
                                  }}
                                />
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="BANK_ACCOUNT" />
                              </div>
                            </div>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (errors.BANK_PAYER_TYPE && touched.BANK_PAYER_TYPE ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-content">
                                {insRole}
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="BANK_PAYER_TYPE" />
                              </div>
                            </div>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (errors.BANK_PAYER_ID && touched.BANK_PAYER_ID ? ' element__form-group--invalid' : '')}>
                              <Field as="select" disabled={isSelf} name="BANK_PAYER_ID" className="element__select">
                                <option value="">請選擇</option>
                                {roleTypeOtps}
                              </Field>
                              <div className="element__error-message">
                                <ErrorMessage name="BANK_PAYER_ID" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* 行動條碼繳費 */}
                    {this.state.activePaymentMethod === PaymentMethod.BarCode && (
                      <>
                        <div className="insure-process-payment__part">
                          <span className="insure-process-payment__part-title">行動條碼支付方式及說明：</span>
                          {
                            _.map(this.props.barcodeNoticeCodes, (code: Code, index: number) => {
                              return <p className="barcode-info" key={index}>{commonService.htmlParser(code.CODE_VALUE)}</p>;
                            })
                          }
                        </div>
                        <div className="insure-process-payment__part">
                          <span className="insure-process-payment__part-title">注意事項</span>
                          <p>
                            {
                              _.map(this.props.barcodeNoteCodes, (code: Code, index: number) => {
                                return React.cloneElement(
                                  <>
                                    {`${code.CODE_VALUE}`}<br />
                                  </>
                                  , { key: index }
                                );
                              })
                            }
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
              <div className="insure-process-payment__controls">
                <button
                  type="button"
                  className="element__button element__button--red-border" onClick={() => {
                    if (!this.props.boPayby) this.props.onGoBack(values, this.state);
                  }}
                >
                  返回上一頁
                </button>
                <button id="btn_pay" type="submit" className="element__button element__button--red" disabled={!this.state.agreeContract && this.state.activePaymentMethod !== PaymentMethod.BarCode}>確認支付</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
};

export default InsureProcessPayment;
